/* eslint-disable no-return-assign */
/* eslint-disable no-await-in-loop */
import clonedeep from 'lodash.clonedeep';


import { getRules, runRulesForWorkflow, cleanWorkflowSteps } from '../utils/rules';




const state = {
    tempRules: {},
    rulesInPlay: new Set(),
};


const mutations = {
    setTempRules: (state, rule) => (state.tempRules = { ...state.tempRules, ...rule }),
    resetTempRules: (state) => state.tempRules = {},
    setRulesInPlay: (state, rules) => state.rulesInPlay = new Set([...rules]), 
};

const actions = {
    runRules: async ({...veuxArgs}, payload) => {
       
        const { dispatch, rootGetters } = veuxArgs;
      
        // resest rules
        dispatch('resetTempRules');
        dispatch('setRulesInPlay', [])

        // get clone of workflow steps 
        let workflowSteps = payload || clonedeep(await rootGetters['workflow/wfSteps']);

        // clean workflow steps
        workflowSteps = await cleanWorkflowSteps(workflowSteps)

        // run rules for workflow
        workflowSteps = await runRulesForWorkflow({...veuxArgs})(workflowSteps);

        // update workflow steps
        return workflowSteps;
    },
    setTempRules: ({commit}, payload) =>  commit('setTempRules', payload),
    setRulesInPlay: ({commit}, payload) => commit('setRulesInPlay', payload),
    resetTempRules: ({commit}) => commit('resetTempRules'),
    
};

const getters = {
    getHcubeRules: (state, getters, rootState) => rootState.hcube.productIncludeExclude,
    getTempRules: (state) => state.tempRules,
    getStepRule: (state) => (step) => state.tempRules[step],
    getRulesInPlay: (state) => state.rulesInPlay,
    getSelectedProductWithRules: (state, getters) => async (workflowSteps) => {
        let currentRuleKeys = [];
        const currentRules = await getRules(await getters.getHcubeRules, workflowSteps);

        if (currentRules) {
            for (const stepRules of Object.values(currentRules)) 
                currentRuleKeys = [...currentRuleKeys, Object.keys(stepRules)].flat();
        }
        return new Set([...currentRuleKeys])
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}